import {ContentRoute} from "../../models/Route";
import FluxoList from "./fluxoList";
import FluxoEditor from "./fluxoEditor";

// Cadastro de fluxos (#480058). Tipos e regras da tela em ./modelo.

export const fluxos_content_routes: Array<ContentRoute> = [
    {
        'path': '/fluxos',
        'description': 'Fluxos',
        'exact': true,
        'component': FluxoList,
        'menu': true
    },
    {
        'path': '/fluxos/incluir',
        'description': 'Incluir Fluxo',
        'exact': true,
        'component': FluxoEditor,
        'menu': false
    },
    {
        'path': '/fluxos/alterar/:id',
        'description': 'Alterar Fluxo',
        'exact': true,
        'component': FluxoEditor,
        'menu': false
    },
    {
        'path': '/fluxos/visualizar/:id',
        'description': 'Visualizar Fluxo',
        'exact': true,
        'component': FluxoEditor,
        'menu': false
    },
    {
        'path': '/fluxos/duplicar/:id',
        'description': 'Duplicar Fluxo',
        'exact': true,
        'component': FluxoEditor,
        'menu': false
    },
];

export default fluxos_content_routes;
